"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconBtnTooltip = _interopRequireDefault(require("../IconBtnTooltip"));

require("./css/NotificationCard.styles.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NotificationCard = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationCard, _React$Component);

  var _super = _createSuper(NotificationCard);

  function NotificationCard(props) {
    var _this;

    _classCallCheck(this, NotificationCard);

    _this = _super.call(this, props);
    _this.state = {
      successMessageTimeoutID: null,
      cardClass: 'NotificationsCard_cardContainer_hide'
    };
    _this.dismissHandle = _this.dismissHandle.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(NotificationCard, [{
    key: "dismissHandle",
    value: function dismissHandle() {
      var _this2 = this;

      this.setState({
        cardClass: 'NotificationsCard_cardContainer_hide'
      }, function () {
        setTimeout(function () {
          return _this2.props.onDismiss(_this2.props.id);
        }, 300);
      });
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this3 = this;

      if (this.props.messageType === 'success') {
        var successMessageTimeoutID = setTimeout(function () {
          _this3.dismissHandle();
        }, 3000);
        this.setState({
          successMessageTimeoutID: successMessageTimeoutID
        });
      }

      setTimeout(function () {
        _this3.setState({
          cardClass: 'NotificationsCard_cardContainer_show'
        });
      }, 10);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.successMessageTimeoutID !== null) {
        clearTimeout(this.state.successMessageTimeoutID);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var colorBarClass = 'NotificationsCard_colorBarError';

      if (this.props.messageType === 'success') {
        colorBarClass = 'NotificationsCard_colorBarSuccess';
      } else if (this.props.messageType === 'warning') {
        colorBarClass = 'NotificationsCard_colorBarWarn';
      }
      /* eslint-disable indent */


      return /*#__PURE__*/_react["default"].createElement("div", {
        className: this.state.cardClass
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: colorBarClass
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "NotificationsCard_messageBody"
      }, this.props.messageType === 'genericError' ? 'There was an issue communicating with the server. Please try again later, or contact my529 if you continue to experience this issue.' : this.props.message), /*#__PURE__*/_react["default"].createElement("div", {
        className: "NotificationsCard_closeButton"
      }, /*#__PURE__*/_react["default"].createElement(_IconBtnTooltip["default"], {
        icon: "close",
        onClick: function onClick() {
          return _this4.dismissHandle();
        },
        title: "Close"
      })));
      /* eslint-enable indent */
    }
  }]);

  return NotificationCard;
}(_react["default"].Component);

_defineProperty(NotificationCard, "propTypes", {
  message: _propTypes["default"].node.isRequired,
  messageType: _propTypes["default"].oneOf(['success', 'error', 'genericError', 'warning']).isRequired,
  id: _propTypes["default"].string.isRequired,
  onDismiss: _propTypes["default"].func.isRequired
});

var _default = NotificationCard;
exports["default"] = _default;